export const loginC2 = {
  "langID00018":"ip",
  "langID00019":"port",
  "langID00020":"ana_domain",
  "langID00021":"tf_urls",
  "langID00022":"ana_hostname",
  "langID00023":"ana_country",
  "langID00024":"ana_asn",
  "langID00025":"ana_asn_description",
  "langID00026":"ana_asn_registry",
  "langID00027":"ana_cert_sha1",
  "langID00028":"ana_cert_subject",
  "langID00029":"ana_cert_issuer",
  "langID00030":"uni_tls",
  "langID00031":"sbj_ja3_md5",
  "langID00032":"uni_first_seen",
  "langID00033":"uni_last_seen"
};

export const stix = [
{"_id":"1","img":"https://user0514.cdnw.net/shared/img/thumb/AI_24911400025_TP_V.jpg","title":"メールボム攻撃とMS Teamsでのビッシングを組み合わせた手法を、複数のランサムウェアアクターが採用","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["CarbonSteal"],"id":"S0529","name":"CarbonSteal","url":"https://attack.mitre.org/software/S0529","version":15.1},
{"_id":"2","img":"https://user0514.cdnw.net/shared/img/thumb/ai_afi8_2491700024-image_TP_V.jpg","title":"Google広告がおかしなことに？公然と行われるマルバタイジングキャンペーンを単純な方法で発見","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["DroidJack"],"id":"S0320","name":"DroidJack","url":"https://attack.mitre.org/software/S0320","version":15.1},
{"_id":"3","img":"https://user0514.cdnw.net/shared/img/thumb/AV8854024_TP_V4.jpg?w=500,h=auto","title":"米国による自動車部品の輸入禁止措置、サプライチェーンの混乱を引き起こす恐れ","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["GoldenEagle"],"id":"S0551","name":"GoldenEagle","url":"https://attack.mitre.org/software/S0551","version":15.1},
{"_id":"4","img":"https://user0514.cdnw.net/shared/img/thumb/zubo25_DSC08080_TP_V4.jpg?w=500,h=auto","title":"HPEがデータ侵害の有無を調査、同社データを販売するとのハッカーの主張受け","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Allwinner"],"id":"S0319","name":"Allwinner","url":"https://attack.mitre.org/software/S0319","version":15.1},
{"_id":"5","img":"https://user0514.cdnw.net/shared/img/thumb/yudai_s1210013_TP_V4.jpg?w=500,h=auto","title":"Flashpointのインテリジェンスに基づく展望：2025年の脅威ランドスケープ","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["FlixOnline"],"id":"S1103","name":"FlixOnline","url":"https://attack.mitre.org/software/S1103","version":15.1},
{"_id":"6","img":"https://user0514.cdnw.net/shared/img/thumb/AI_cloth_84s063_TP_V4.jpg?w=500,h=auto","title":"MITREが「D3FEND 1.0」を発表　目的は脅威に対抗するサイバーセキュリティ技術の標準化","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Hornbill"],"id":"S1077","name":"Hornbill","url":"https://attack.mitre.org/software/S1077","version":15.1},
{"_id":"7","img":"https://user0514.cdnw.net/shared/img/thumb/AIai_2412s8056-SL_TP_V4.jpg?w=500,h=auto","title":"日本など世界各地が標的に：新IoTボットネットが大規模DDoSを仕掛ける","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Gooligan","Ghost Push"],"id":"S0290","name":"Gooligan","url":"https://attack.mitre.org/software/S0290","version":15.1},
{"_id":"8","img":"https://user0514.cdnw.net/shared/img/thumb/cut-fruit1_02-9411_TP_V4.jpg?w=500,h=auto","title":"IntelBrokerの正体に接近：OSINTで得られた手がかりとは","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Bread","Joker"],"id":"S0432","name":"Bread","url":"https://attack.mitre.org/software/S0432","version":15.1},
{"_id":"9","img":"https://user0514.cdnw.net/shared/img/thumb/pakutexture12_TP_V4.jpg?w=500,h=auto","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["TrickMo"],"id":"S0427","name":"TrickMo","url":"https://attack.mitre.org/software/S0427","version":15.1},
{"_id":"11","img":"https://user0514.cdnw.net/shared/img/thumb/pakutexture39_TP_V4.jpg?w=500,h=auto","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["CarbonSteal"],"id":"S0529","name":"CarbonSteal","url":"https://attack.mitre.org/software/S0529","version":15.1},
{"_id":"12","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["DroidJack"],"id":"S0320","name":"DroidJack","url":"https://attack.mitre.org/software/S0320","version":15.1},
{"_id":"13","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["GoldenEagle"],"id":"S0551","name":"GoldenEagle","url":"https://attack.mitre.org/software/S0551","version":15.1},
{"_id":"14","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Allwinner"],"id":"S0319","name":"Allwinner","url":"https://attack.mitre.org/software/S0319","version":15.1},
{"_id":"15","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["FlixOnline"],"id":"S1103","name":"FlixOnline","url":"https://attack.mitre.org/software/S1103","version":15.1},
{"_id":"16","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Hornbill"],"id":"S1077","name":"Hornbill","url":"https://attack.mitre.org/software/S1077","version":15.1},
{"_id":"17","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Gooligan","Ghost Push"],"id":"S0290","name":"Gooligan","url":"https://attack.mitre.org/software/S0290","version":15.1},
{"_id":"18","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Bread","Joker"],"id":"S0432","name":"Bread","url":"https://attack.mitre.org/software/S0432","version":15.1},
{"_id":"19","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["TrickMo"],"id":"S0427","name":"TrickMo","url":"https://attack.mitre.org/software/S0427","version":15.1},
{"_id":"21","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["CarbonSteal"],"id":"S0529","name":"CarbonSteal","url":"https://attack.mitre.org/software/S0529","version":15.1},
{"_id":"22","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["DroidJack"],"id":"S0320","name":"DroidJack","url":"https://attack.mitre.org/software/S0320","version":15.1},
{"_id":"23","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["GoldenEagle"],"id":"S0551","name":"GoldenEagle","url":"https://attack.mitre.org/software/S0551","version":15.1},
{"_id":"24","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Allwinner"],"id":"S0319","name":"Allwinner","url":"https://attack.mitre.org/software/S0319","version":15.1},
{"_id":"25","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["FlixOnline"],"id":"S1103","name":"FlixOnline","url":"https://attack.mitre.org/software/S1103","version":15.1},
{"_id":"26","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Hornbill"],"id":"S1077","name":"Hornbill","url":"https://attack.mitre.org/software/S1077","version":15.1},
{"_id":"27","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Gooligan","Ghost Push"],"id":"S0290","name":"Gooligan","url":"https://attack.mitre.org/software/S0290","version":15.1},
{"_id":"28","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["Bread","Joker"],"id":"S0432","name":"Bread","url":"https://attack.mitre.org/software/S0432","version":15.1},
{"_id":"29","img":"logo","title":"タイトル","tag":["#tag1","#tag2"],"date":"2024-10-11","aliases":["TrickMo"],"id":"S0427","name":"TrickMo","url":"https://attack.mitre.org/software/S0427","version":15.1},

];


export const c2 = {
  "langID00018":"ip",
  "langID00019":"port",
  "langID00020":"ana_domain",
  "langID00021":"tf_urls",
  "langID00022":"ana_hostname",
  "langID00023":"ana_country",
  "langID00024":"0",
  "langID00025":"0",
  "langID00026":"0",
  "langID00027":"0",
  "langID00028":"0",
  "langID00029":"0",
  "langID00030":"0",
  "langID00031":"0",
  "langID00032":"0",
  "langID00033":"0"
};
export const loginDl = {
  "langID00008":"tf_urls",  
  "langID00020":"ana_domain",  
  "langID00018":"ana_ip", 
  "langID00019":"port",
  "langID00022":"ana_hostname",
  "langID00023":"ana_country",
  "langID00024":"ana_asn",
  "langID00025":"ana_asn_description",
  "langID00026":"ana_asn_registry",
  "langID00027":"ana_cert_sha1",
  "langID00028":"ana_cert_subject",
  "langID00029":"ana_cert_issuer",
  "langID00030":"uni_tls",
  "langID00031":"sbj_ja3_md5",
  "langID00032":"uni_first_seen",
  "langID00033":"uni_last_seen"
};
export const dl = {
  "langID00008":"tf_urls",  
  "langID00020":"ana_domain",  
  "langID00018":"ana_ip", 
  "langID00019":"port",
  "langID00022":"ana_hostname",
  "langID00023":"ana_country",
  "langID00024":"0",
  "langID00025":"0",
  "langID00026":"0",
  "langID00027":"0",
  "langID00028":"0",
  "langID00029":"0",
  "langID00030":"0",
  "langID00031":"0",
  "langID00032":"0",
  "langID00033":"0"
};
export const loginPhish = {
  "langID00008":"tf_urls",  
  "langID00020":"ana_domain",  
  "langID00018":"ana_ip", 
  "langID00019":"port",
  "langID00022":"ana_hostname",
  "langID00023":"ana_country",
  "langID00024":"ana_asn",
  "langID00025":"ana_asn_description",
  "langID00026":"ana_asn_registry",
  "langID00027":"ana_cert_sha1",
  "langID00028":"ana_cert_subject",
  "langID00029":"ana_cert_issuer",
  "langID00030":"uni_tls",
  "langID00032":"uni_first_seen",
  "langID00033":"uni_last_seen"
};
export const phish = {
  "langID00008":"tf_urls",  
  "langID00020":"ana_domain",  
  "langID00018":"ana_ip", 
  "langID00019":"port",
  "langID00022":"ana_hostname",
  "langID00023":"ana_country",
  "langID00024":"0",
  "langID00025":"0",
  "langID00026":"0",
  "langID00027":"0",
  "langID00028":"0",
  "langID00029":"0",
  "langID00030":"0",
  "langID00032":"0",
  "langID00033":"0"
};
export const loginHash = {
  "langID00043":"md5",
  "langID00044":"sha256",
  "langID00045":"sha1",
  "langID00041":"uni_file_type",
  "langID00046":"uni_file_name",
  "langID00047":"ana_malware",
  "langID00048":"ana_malware_alias",
  "langID00049":"ana_mitre_url",
  "langID00050":"ana_malpedia_url",
  "langID00032":"uni_first_seen",
  "langID00033":"uni_last_seen"
};
export const hash = {
  "langID00043":"md5",
  "langID00044":"sha256",
  "langID00045":"sha1",
  "langID00041":"uni_file_type",
  "langID00046":"0",
  "langID00047":"0",
  "langID00048":"0",
  "langID00049":"0",
  "langID00050":"0",
  "langID00032":"0",
  "langID00033":"0"
};

type arr = {
    $oid : string
};
export type C2List = {
    _id:arr
    ip:string
    port:number
    hash__ids:arr[]
    sbs__ids:arr[]
    sbs___record_datetime:string
    sbs_listing_date:string
    sbs_first_seen:string
    sbs_last_seen:string
    sbs_cert_sha1:string
    sbs_cn:string
    sbs_dn:string
    sbs_tls:string
    sbs_listing_reason:string
    sbs_signature:string
    dl__ids:arr[]
    sbj__ids:arr[]
    sbj___record_datetime:string
    sbj_timestamp:string
    sbj_ja3_md5:string
    sbj_malware:string
    host:string
    ft__ids:arr[]
    ft___record_datetime:string
    ft_first_seen:string
    ft_last_online:string
    ft_as_name:string
    ft_as_number:string
    ft_country:string
    ft_malware:string
    tf__ids:arr[]
    tf___record_datetime:string
    tf_first_seen:string
    tf_last_seen:string
    tf_confidence_level:number
    tf_urls:string
    urls:arr[]
    tf_malware_printable:arr[]
    ana_asn:string
    ana_asn_description:string
    ana_asn_registry:string
    ana_country:string
    ana_hostname:string
    ana_domain:string
    ana_domain_registrar:string
    ana_domain_creation_date:string
    ana_domain_updated_date:string
    ana_domain_expiration_date:string
    ana_ip:string
    ana_tls:string
    ana_cert_sha1:string
    ana_cert_subject:string
    ana_cert_issuer:string
    ana_cert_not_valid_before:string
    ana_cert_not_valid_after:string
    uni_hostname:string
    uni_asn:string
    uni_asn_name:string
    uni_country:string
    uni_cert_sha1:string
    uni_cert_subject:string
    uni_cert_issuer:string
    uni_tls:string
    uni_first_seen:string
    uni_last_seen:string
    uni_signature:string
    bld_ioc_types:arr[]
    __create_polling_id:string
    __create_datetime:string
    __polling_id:string
    __record_datetime:string
    __stage:number
    __raw_transfer_flag:string
    __stix_transfer_flag:string
    ddb__ids:arr[]
  };
  
  export type Tag = {
    _id:arr
    id:string
    name:string
  };
  export type Notice = {
    _id:arr
  　start_date:string
  　end_date:string
  　type:string
  　title:string
  　content:string
  　disp_flag:string
  };


